'use client';

import {useState, useEffect} from 'react';
import useTopStyle from '../../utils/useTopStyle';
import {useMediaQuery} from 'react-responsive';
import Link from 'next/link';
import technology from '../../data/technology';

const Technology = () => {
  // TODO: for now
  return null;

  const screenWidth = useMediaQuery({query: '(max-width: 768px)'});
  const [isVisible, setVisible] = useState(false);
  const [logoArr, setLogoArr] = useState(technology);
  const ref = useTopStyle(360);

  useEffect(() => {
    const logoArr = !screenWidth ? technology : isVisible ? technology : technology.slice(0, 6);
    setLogoArr(logoArr);
  }, [screenWidth, isVisible]);

  const onClick = () => {
    setVisible(isVisible => !isVisible);
  };

  const technologyItems = logoArr.map((item, index) => {
    const {text, description, ico} = item;
    const hoverStyle = {backgroundImage: `url(/svg/${ico})`};

    return (
      <div className='technology-item' key={index}>
        <div className='technology-icon'>
          <div className='technology-ico' style={hoverStyle}></div>
        </div>
        <p className='text'>{text}</p>
        <div className='technology-hover' key={index}>
          <div className='hover-icon' style={hoverStyle}></div>
          <p className='hover-text'>{text}</p>
          <p className='hover-description'>{description}</p>
        </div>
      </div>
    );
  });

  return (
    <div className='technology' ref={ref} id='technology'>
      <div className='container'>
        <h3 className='subtitle'>Why use cylerian</h3>
        <div className='wrapper'>
          <div className='technology-items'>{technologyItems}</div>
        </div>
        <Link href='platform#technology' className='arrow-link' onClick={onClick}>
          <span>
            {isVisible ? 'Hide all' : 'View more'}
            <span className='arrow-wrapper'>
              <span className='arrow'></span>
            </span>
          </span>
        </Link>
      </div>
    </div>
  );
};

export default Technology;

